const navbarLogic = (dropdownToggles) => {
  dropdownToggles.forEach((toggle) => {
    const minWidth = 1200;
    const minHeight = 560;

    const dropdown = toggle.nextElementSibling;

    function expandDropdown() {
      toggle.setAttribute("aria-expanded", "true");
      dropdown.hidden = false;

      // collapse all other open dropdowns
      dropdownToggles.forEach((otherToggle) => {
        if (otherToggle !== toggle) {
          otherToggle.setAttribute("aria-expanded", "false");
          otherToggle.nextElementSibling.hidden = true;
        }
      });
    }

    function collapseDropdown() {
      toggle.setAttribute("aria-expanded", "false");
      dropdown.hidden = true;
    }

    function expandCollapseDropdown() {
      const isExpanded = toggle.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        collapseDropdown();
      } else {
        expandDropdown();
      }
    }

    function handleHover() {
      const isTouch = matchMedia("(hover: none)").matches;
      if (!isTouch) {
        expandDropdown();
      }
    }

    function handleKeydown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        expandCollapseDropdown();
      }
    }

    function handleBlur() {
      setTimeout(() => {
        if (
          window.innerWidth > minWidth &&
          window.innerHeight > minHeight &&
          !toggle.contains(document.activeElement) &&
          !dropdown.contains(document.activeElement)
        ) {
          collapseDropdown();
        }
      }, 100);
    }

    toggle.removeEventListener("click", expandCollapseDropdown);
    toggle.addEventListener("click", expandCollapseDropdown);

    toggle.removeEventListener("keydown", handleKeydown);
    toggle.addEventListener("keydown", handleKeydown);

    toggle.removeEventListener("mouseenter", handleHover);
    toggle.addEventListener("mouseenter", handleHover);
    toggle.parentElement.removeEventListener("mouseleave", collapseDropdown);
    toggle.parentElement.addEventListener("mouseleave", collapseDropdown);

    toggle.removeEventListener("blur", handleBlur);
    toggle.addEventListener("blur", handleBlur);
  });
};

function mobileLogic() {
  // Mobile only search bar
  const searchButton = document.querySelector(".mobile-search-toggle");
  const searchWidget = document.querySelector(".mobile-search-container");
  function handleSearchClick() {
    searchWidget.removeAttribute("hidden");
    searchButton.setAttribute("hidden", "true");
  }
  if (searchButton) {
    searchButton.removeEventListener("click", handleSearchClick);
    searchButton.addEventListener("click", handleSearchClick);
  }

  // Mobile nav
  const mobileToggle = document.querySelector(".navbar-mobile-toggle");
  const mobileMenu = document.querySelector(".main-navbar .nav-menu");
  const mobileTopToggle = document.querySelector(".mobile-top-nav-toggle");
  const mobileTopMenu = document.querySelector(".top-navbar .nav-menu");

  function toggleNavigation(trigger, target) {
    if (trigger && target) {
      const isExpanded = trigger.getAttribute("aria-expanded") === "true";
      trigger.setAttribute("aria-expanded", !isExpanded);
      target.classList.toggle("show", !isExpanded);
      document.body.classList.toggle("no-scroll", !isExpanded);
    }
  }

  function handleMobileToggleClick() {
    toggleNavigation(mobileToggle, mobileMenu);
  }

  function handleMobileTopToggleClick() {
    toggleNavigation(mobileTopToggle, mobileTopMenu);
  }

  if (mobileToggle && mobileMenu) {
    mobileToggle.removeEventListener("click", handleMobileToggleClick);
    mobileToggle.addEventListener("click", handleMobileToggleClick);
  }

  if (mobileTopToggle && mobileTopMenu) {
    mobileTopToggle.removeEventListener("click", handleMobileTopToggleClick);
    mobileTopToggle.addEventListener("click", handleMobileTopToggleClick);
  }

  // Close all mobile menus on window resize
  function handleViewportChange() {
    const query = "(min-width: 1200px) and (min-height: 560px)";
    const mql = window.matchMedia(query);

    const checkState = (e) => {
      if (e.matches) {
        document.querySelectorAll(".nav-menu").forEach((menu) => {
          menu.classList.remove("show");
        });
        document.querySelectorAll(".nav-toggle").forEach((toggle) => {
          toggle.setAttribute("aria-expanded", "false");
        });
        document.body.classList.remove("no-scroll");
      }
    };

    mql.addEventListener("change", checkState);
    checkState(mql);
  }
  handleViewportChange();
}

function initNavBar() {
  const togglesTop = document.querySelectorAll(
    ".top-navbar .nav-item.has-child>button",
  );
  const togglesMain = document.querySelectorAll(
    ".main-navbar .nav-item.has-child>button",
  );
  navbarLogic(togglesTop);
  navbarLogic(togglesMain);
  mobileLogic();
}

Liferay.on("allPortletsReady", initNavBar);
Liferay.on("endNavigate", initNavBar);
